<template>
    <v-app>
        <v-toolbar fixed class="m-instagram-toolbar" color="white"></v-toolbar>

        <v-content class="m-instagram pt-5 mt-5">
            <v-container fluid fill-height>
                <v-layout align-top justify-center>
                    <child/>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
  export default {

  }
</script>


// WEBPACK FOOTER //
// resources/js/layouts/instagram.vue